import { gql } from "@apollo/client";

const GET_APPLICATION_INFO = gql`
  query getApplicationInfo {
    getApplicationInfo {
      status
      applicationStatus
      firstName
      lastName
      address {
        address_type
        street
        city
        state
        zip
        country
        unit_number
      }
      dob
      email
      phoneNumber
    }
    getApplicationStep {
      resumeAtStep
      meetsBalanceThreshold
      needsIdUpload
    }
  }
`;

/* LinkBankV2 */
const GET_APP_INFO_AND_ACCOUNTS = gql`
  query getBankInfo {
    getBankAccounts {
      status
      message
      meetsBalanceThreshold
      aggregatorOverride
      unlinkedAccountsFound
      accountsByLogin {
        institutionLoginId
        aggregator
        accounts {
          userAccountId
          name
          type
          mask
        }
        institution {
          institutionId
          name
          logo
        }
        relink {
          url
          itemId
          linkToken
        }
      }
    }
    getApplicationInfo {
      email
    }
    finicityConnect {
      customer_id
      link
    }
  }
`;

export {
  GET_APPLICATION_INFO,
  GET_APP_INFO_AND_ACCOUNTS,
};